import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  superAdminDashboard,
  superAdminProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import ProfileDetails from "../common/ProfileDetails";
import SuperAdminDashboardAgencyDetailsHistory from "./SuperAdminDashboardAgencyDetailsHistory";
import BreadcrumbMenu from "../common/BreadcrumbMenu";

export default function SuperAdminDashboardAgencyDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // activeSuperAdminDashboardAgencyDetailsTabIndex
    localStorage.setItem("activeSuperAdminDashboardAgencyDetailsTabIndex", val);
  };

  /*===========================================
              main
  ===========================================*/
  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={superAdminDashboard}
        profileLink={superAdminProfile}
        activeLink={activeLinkDashboard}
      />

      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <BreadcrumbMenu
            menuObj={[
              {
                title: "Dashboard",
                type: "goBackButton",
              },
              {
                title: "Agency Name",
              },
            ]}
          />
          <h1 className="mt-dashboard-title">Agency Name</h1>
        </div>
        <div className="mt-platform-tabs">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem(
                "activeSuperAdminDashboardAgencyDetailsTabIndex"
              )
            )}
            onSelect={handleOnSelect}
          >
            <TabList>
              <Tab>Details</Tab>
              <Tab>Requirement History</Tab>
            </TabList>
            <TabPanel>
              <ProfileDetails
                isSkillListPresent={true}
                displayCompanyNameAndPassword={true}
              />
            </TabPanel>
            <TabPanel>
              <SuperAdminDashboardAgencyDetailsHistory />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
